export const chatSourceCookieKey = 'chat-source';
//# sourceMappingURL=internalTools.js.map